import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SettingsComponent} from './settings.component';


export const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingsComponent,
    data: {
      'expectedRoles': ['Admin' , 'IT']
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(settingsRoutes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {
}


// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings-routing.module.ts